import { EntityTypes } from "../helpers/constant";
export default {
  setriskprofileresponse(payload) {
    let p = {};
    let riskdata = {};
    payload.splice(0, 0, this.getCustomRiskProfile());
    p.data = payload;

    for (let i = 0; i < p.data.length; i++) {
      p.data[i].text =
        payload[i].questionnaireName +
        (payload[i].profileName && payload[i].questionnaireName
          ? "- " + payload[i].profileName
          : payload[i].profileName);

      p.data[i].value = payload[i].profileId;
    }
    let filtereddata = payload.filter((x) => x.selectedMembers.length > 0);
    for (let i = 0; i < filtereddata.length; i++) {
      for (let j = 0; j < filtereddata[i].selectedMembers.length; j++) {
        riskdata[filtereddata[i].selectedMembers[j]] = filtereddata[i];
      }
    }
    p.defaultriskprofiles = riskdata;
    return p;
  },

  getCustomRiskProfile() {
    return {
      profileName: "Custom",
      profileId: 0,
      selectedMembers: [],
      questionaireId: "0",
      questionnaireName: "",
      growthRate: 0,
      taxFree: 0,
      incomeRate: 0,
      frankingRate: 0,
    };
  },
  getRiskProfileId(riskdata, riskProfileId) {
    let riskId = 0;
    if (riskdata) {
      let isdataExisting = riskdata.findIndex(
        (sr) => sr.profileId == riskProfileId
      );
      if (isdataExisting >= 0) {
        return riskProfileId;
      }
    }
    return riskId;
  },
  getRiskProfileValue(riskdata, clientId, ownerId, entityType, proName) {
    let proValue = 0;
    if (riskdata) {
      if (entityType == EntityTypes.both) {
        if (riskdata[clientId]) {
          return riskdata[clientId][proName];
        }
      } else if (riskdata[ownerId]) {
        return riskdata[ownerId][proName];
      }
    }
    return proValue;
  },
  getRiskProfile(riskdata, clientId, ownerId, entityType) {
    let proValue = {
      profileId: 0,
      incomeRate: 0,
      growthRate: 0,
      frankingRate: 0,
    };
    if (riskdata) {
      if (entityType == EntityTypes.both) {
        if (riskdata[clientId]) {
          return riskdata[clientId];
        }
      } else if (riskdata[ownerId]) {
        return riskdata[ownerId];
      }
    }
    return proValue;
  },
};
